import Purchase from './Purchase.js';

export default Purchase;